import ChevDown from "@/seed/components/elements/chev-down";
import RoundInfo from "@/seed/components/elements/round-info";
import TokenSaleHero from "@/seed/components/modules/token-sale/token-sale-hero";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { getWhitelistResultContent } from "@/seed/utils/sale-info";
// import { data as tokenSaleData } from "@/seed/shared/token/token-sale";
// import { data as seedRoundData } from "@/seed/shared/token/seed-round/round-info";
import { useContext } from "react";

const WhitelistWin = () => {
    const { layoutContentDef, saleEvent } = useContext(PoolContext);
    if (!layoutContentDef || !saleEvent) return <div>Loading</div>;
    console.log("WhitelistWin", { layoutContentDef, saleEvent });
    const whitelistResultContent = getWhitelistResultContent(saleEvent, layoutContentDef);

    return (
        <>
            <div className="absolute">
                <section id="hero" className="bg-[url('/img/hero.png')] bg-center bg-cover">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
                <section id="user-guide" className="">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
            </div>

            <div className="absolute w-screen top-[20%] landscape:top-[30%]">
                <div className="container mx-auto flex flex-col items-center justify-center w-full">
                    <TokenSaleHero
                        data={{
                            ...layoutContentDef.tokenSaleHero,
                            countdown: {
                                ...layoutContentDef.tokenSaleHero.countdown,
                                ...saleEvent.countdown,
                            },
                            saleInfo: saleEvent,
                            whitelistResult: whitelistResultContent,
                        }}
                    />
                    <ChevDown />
                    <RoundInfo data={saleEvent.roundOverview} />
                </div>
            </div>
        </>
    );
};

export default WhitelistWin;
